import React from "react";

const OrderSummary = ({ cartData }) => {
  return (
    <div>
      {/* <p className='text-xl text-left my-2 pl-2 font-medium py-2'>3. Order Summary</p> */}
      {cartData?.map((product) => {
        return (
          <div
            key={product.productDetail.productId}
            className="flex justify-between mb-2 p-3 px-5 bg-white border-gray-200 rounded-lg shadow"
          >
            <div className="flex  justify-start ">
              <img
                src={product.productDetail.img}
                alt={product.productDetail.productName}
                className="w-[70px] h-[70px] rounded-md"
              />
              <div>
                <div className="ml-3 text-left -mt-1">
                  <p className="font-semibold">
                    {product.productDetail.productName}
                  </p>
                  <p>
                    {product?.productDetail?.variants[0]?.color && (
                      <button className="cursor-default py-1 px-2 me-2 mb-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700  ">
                        {product.productDetail.variants[0]?.color}
                      </button>
                    )}
                    {product?.productDetail?.variants[0]?.dimension && (
                      <button className=" cursor-default py-1 px-2 me-2 mb-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700  ">
                        {product.productDetail.variants[0]?.dimension}
                      </button>
                    )}
                    {product?.productDetail?.variants[0]?.weight && (
                      <button className="cursor-default py-1 px-2 me-2 mb-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700  ">
                        {product.productDetail.variants[0]?.weight}
                      </button>
                    )}
                    {product?.productDetail?.variants[0]?.materialType && (
                      <button className="cursor-default py-1 px-2 me-2 mb-2 text-xs font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700  ">
                        {product.productDetail.variants[0]?.materialType}
                      </button>
                    )}
                  </p>
                  <p className="-mt-2">
                    Price {product.productDetail.priceDetails.sellingPrice}/-
                  </p>
                </div>
                <div>
                  <p className="text-sm pl-3 text-left">
                    Qty : {product.quantity}
                  </p>
                </div>
              </div>
            </div>

            <div className="font-semibold">
              <p>
                ₹
                {product.productDetail.priceDetails.sellingPrice *
                  product.quantity}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OrderSummary;
